import React from 'react' ; 
import "./specificGroup.css" ; 
import { Outlet } from 'react-router-dom';

const SpecificGroupPage = () => {
  return (
    <section className='specific-group-section'>
        <Outlet />
    </section>
  )
}

export default SpecificGroupPage
